import React from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

const SmartengoElement = styled.h5`
  font-family: "Roboto";
  font-weight: bold;
  font-size: 20px;
  line-height: 38px;
  color: #303030;
  margin: 0 5px;
  cursor: pointer;
`;

const TitleElement = styled.h5`
  font-family: "Roboto";
  font-weight: normal;
  font-size: 20px;
  line-height: 38px;
  color: #777777;
  margin: 0;
  cursor: pointer;
`;

const Title = () => {
  const history = useHistory();
  const redirectHome = () => {
    history.push("/");
  };
  return (
    <React.Fragment>
      <SmartengoElement onClick={redirectHome}>Tally Vision</SmartengoElement>
      <TitleElement onClick={redirectHome}></TitleElement>
    </React.Fragment>
  );
};

export default Title;
